  <div id="login" class="inner-scroll" fxLayout="row" fxLayoutAlign="start">
    <ng-container *ngIf="!contenidoExterno && !infoVideo.enable">
      <div id="bgImg"></div>
    </ng-container>
    <div id="login-intro" fxFlex fxHide fxShow.gt-xs>
      <ng-container *ngIf="contenidoExterno">
        <iframe class="iframeExt" [src]="urlSafe" width="100%"></iframe>
      </ng-container>
      <ng-container *ngIf="!contenidoExterno">
        <ng-container *ngIf="infoVideo.enable">
          <video [src]="infoVideo.video" autoplay [loop]="infoVideo.loop" [muted]="infoVideo.mute" class="iframeExt"></video>
        </ng-container>
        <ng-container *ngIf="!infoVideo.enable">
          <div class="logo" [@animate]="{value:'*',params:{scale:'0.2'}}">
            <img [src]="urlAssets + configLogin.logoBroker">
          </div>
          <div class="title" [@animate]="{value:'*',params:{delay:'50ms',y:'25px'}}" [innerHTML]="configLogin.titulo | translate"></div>
          <!-- <div class="description" [@animate]="{value:'*',params:{delay:'100ms',y:'25px'}}" [innerHTML]="'LOGIN.LANDING.NAVEG' | translate"></div> -->
        </ng-container>
      </ng-container>
    </div>

    <div id="login-form-wrapper" fusePerfectScrollbar [@animate]="{value:'*',params:{delay:'300ms',x:'100%'}}">

      <div id="login-form">

        <div class="logo" fxHide.gt-xs>
          <img [src]="urlAssets + configLogin.logoBroker">
        </div>
        <div class="logoCGO" *ngIf="configLogin.logoLogin != ''" fxHide.xs fxShow.gt-xs>
          <img [src]="urlAssets + configLogin.logoLogin">
        </div>

        <!--------selector de idiomas--->
        <form class="">
          <mat-form-field appearance="outline">
            <mat-label>{{'LOGIN.FORM.INPUT.LANGSEL' | translate}}</mat-label>
            <mat-select [(value)]="selectedLanguage" required>
              <mat-option *ngFor="let lang of languages" (click)="setLanguage(lang.id)" [value]="lang.id">
                {{'SELECTOR.'+lang.id | translate}}
              </mat-option>
            </mat-select>
            <mat-icon matSuffix class="secondary-text">language</mat-icon>
            <mat-error>idioma</mat-error>
          </mat-form-field>
        </form>


        <div class="title">{{'LOGIN.FORM.TITULO' | translate}}</div>

        <!-- <form name="loginForm" [formGroup]="loginForm" (submit)="iniciaSesion()" novalidate> -->
          <form name="loginForm" [formGroup]="loginForm" (submit)="login2FA_paso1()" novalidate>

            <mat-form-field appearance="outline">
              <mat-label>{{'LOGIN.FORM.INPUT.EMAIL' | translate}}</mat-label>
              <input matInput name="email" formControlName="email" #email maxlength="50" (keyup)="validacionCaracEmail($event)" (blur)="validacionFormulario()" autocomplete="off">
              <mat-icon matSuffix class="secondary-text">mail</mat-icon>
              <mat-error *ngIf="loginForm.get('email').hasError('required')">
                {{'LOGIN.FORM.VAL.NOTEMAIL' | translate}}
              </mat-error>
              <mat-error *ngIf="!loginForm.get('email').hasError('required') && loginForm.get('email').hasError('email')">
                {{'LOGIN.FORM.VAL.INVEMAIL' | translate}}
              </mat-error>
            </mat-form-field>
            <b style="color:red;" *ngIf="caracteresNoPermitidosEmpresa">  {{'LOGIN.FORM.VAL.CARACT_EMA' | translate}}</b>
            <mat-form-field appearance="outline" style="margin-top:{{mrtopEmail}}">
              <mat-label>{{'LOGIN.FORM.INPUT.PASSWORD' | translate}}</mat-label>
              <input matInput  [type]="hide ? 'password' : 'text'" formControlName="password" #password maxlength="50" (keyup)="validacionPassEmail($event)" (blur)="validacionFormulario()" autocomplete="off">
              <button mat-icon-button matSuffix (click)="mostrarPassword($event);hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                <mat-icon>{{hide ? 'lock' : 'lock_open'}}</mat-icon>
              </button>
              <mat-error>{{'LOGIN.FORM.VAL.PASS' | translate}}</mat-error>
            </mat-form-field>

            <button *ngIf="!isLoading" mat-raised-button color="accent" class="submit-button" aria-label="LOGIN" [disabled]="!emailValidadoCorrectamente && !passValidadoCorrectamente || emailValidadoCorrectamente && !passValidadoCorrectamente || !emailValidadoCorrectamente && passValidadoCorrectamente">
              {{'LOGIN.FORM.SIGNIN' | translate}}
            </button>
            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

          </form>
          <div class="subtitle" fxLayoutAlign="center center"><a class="linkPage" style="color: #3366BB;" (click)="goPassword()">{{'LOGIN.FORM.FORGOTPASSWORD' | translate}}</a></div>

        </div>

      </div>
  </div>
